<template>
    <div class="page-users-prices-settings">
        <AppTable
            primaryKey="id"
            :columns="tableHeaders"
            :rows="usersPrices"
            :isProgressBar="isLoading"
            @search="searchTable"
            @sort="sortTable"
        >
            <template v-slot:priceType="cellPriceTypeData">
                <BaseSelectV2
                    :isFixed="true"
                    :isVirtualScroll="true"
                    :value="getPriceTypeValue(cellPriceTypeData)"
                    :options="priceTypes"
                    @check="checkPriceType($event, cellPriceTypeData)"
                    class="page-users-prices-settings__select"
                />
            </template>
        </AppTable>
    </div>
</template>

<script>
import AppTable from "@/components/Table2/Table.vue";
import BaseSelectV2 from "@/components/Base/BaseSelectV2.vue";
import ServiceUsersPricesSettings from "@/services/ServicesPrice/ServiceUsersPricesSettings.js";

export default {
    name: "PageUsersPricesSettings",
    components: {
        AppTable,
        BaseSelectV2
    },
    data: () => ({
        priceTypes: [
            {
                id: "federal",
                value: "Федеральные"
            },
            {
                id: "regional",
                value: "Региональные"
            }
        ],
        tableHeaders: [
            {
                prop: "login",
                label: "Логин",
                canSorted: true,
                canSearch: true,
                columnStyles: { flexGrow: 1 },
            },
            {
                prop: "full_name",
                label: "Пользователь",
                canSorted: true,
                canSearch: true,
                columnStyles: { flexGrow: 1 },
            },
            {
                prop: "priceType",
                label: "Тип цены",
                canSorted: true,
                canSearchSelect: true,
                searchItems: [
                    {
                        id: "federal",
                        value: "Федеральные"
                    },
                    {
                        id: "regional",
                        value: "Региональные"
                    }
                ],
                isDropdownColumn: true,
                isSlot: true,
                columnStyles: { width: "400px" },
            },
        ],
        usersPrices: [],
        isLoading: false,
        searchData: {},
        sortData: {}
    }),
    mounted() {
        this.getUsersPrices();
    },
    methods: {
        async getUsersPrices() {
            this.isLoading = true;

            try {
                this.usersPrices = await ServiceUsersPricesSettings.getUsersPrices(this.searchData, this.sortData);
            } catch (errorMessage) {
                this.$notify.addNotification({
                    type: "error",
                    title: "Ошибка получения цен пользователей",
                    description: errorMessage,
                    duration: Infinity,
                    position: 'bottom-right'
                });
            } finally {
                this.isLoading = false;
            }
        },
        async checkPriceType(priceTypeItem = {}, cellPriceTypeData = {}) {
            try {
                await ServiceUsersPricesSettings.setUserPriceType(cellPriceTypeData?.row?.id ?? "", priceTypeItem.id);

                const userPriceIndex = this.usersPrices.findIndex(userPrice => userPrice.id === cellPriceTypeData?.row?.id);

                if (userPriceIndex !== -1) this.usersPrices.splice(userPriceIndex, 1, { ...this.usersPrices[userPriceIndex], priceType: priceTypeItem.id });
            } catch (errorMessage) {
                this.$notify.addNotification({
                    type: "error",
                    title: "Ошибка изменения типа цены пользователя",
                    description: errorMessage,
                    duration: Infinity,
                    position: 'bottom-right'
                });
            }
        },
        getPriceTypeValue(cellPriceTypeData) {
            return cellPriceTypeData.cell;
        },
        searchTable(searchData = {}) {
            this.searchData = { ...searchData };

            this.getUsersPrices();
        },
        sortTable(sortData = {}) {
            this.sortData = { ...sortData };

            this.getUsersPrices();
        }
    }
};
</script>

<style lang="scss" scoped>
    .page-users-prices-settings {
        height: 100%;
        padding: 30px;

        ::v-deep .table .row {
            min-width: 100%;
        }

        &__select {
            height: 35px;
            width: 400px;
        }
    }
</style>
